import Client from 'modules/Client'

export default {
  fetchOne (id) {
    return Client.get(`api/aluno/pacote/${id}`)
      .then(response => response.data)
  }
}
